import throttle from 'lodash/throttle';
import app from '../app'; // eslint-disable-line

export default () => {
  const scroll = () => app.emit('window:scroll');
  const resize = () => app.emit('window:resize');

  window.addEventListener('scroll', throttle(scroll, 100));
  window.addEventListener('resize', throttle(resize, 100));

  if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
};
